import { reducerWithInitialState } from "typescript-fsa-reducers"
import planActions from "store/actions/PlanAction"

export interface PlanState {
  plan: any
  page: string
}
const initialState: PlanState = {
  plan: {},
  page: ""
}
// Reduxを利用した画面間共通の見積結果state初期化処理
export const planReducer = reducerWithInitialState(initialState)
  .case(planActions.updatePlan, (state, plan) => {
    return { ...state, plan }
  })
  .case(planActions.updatePage, (state, page) => {
    return { ...state, page }
  })
  .case(planActions.reset, (state) => {
    return { ...state, ...initialState }
  })
  .default((state) => {
    return state
  })
